// app/javascript/controllers/expires_on_editor_controller.js

import { Controller } from "@hotwired/stimulus"
import { walletTabReturnUrl, hasWalletTabContext } from "../utils/wallet_tab_return_url"

export default class extends Controller {
  // 💡 ターゲットに noExpirationCheck を追加
  static targets = ["expiresOnInput", "originalDate", "errorMessages", "submitButton", "modalTitle", "form", "noExpirationCheck"] 
  
  connect() {
    this.element.addEventListener('show.bs.modal', this.setInitialData.bind(this));
  }

  // ----------------------------------------------------
  // 1. モーダル表示時にデータとURLをセット
  // ----------------------------------------------------
  setInitialData(event) {
    const button = event.relatedTarget
    const masterTreatmentId = button.dataset.masterTreatmentId
    const originalExpiresOn = button.dataset.originalExpiresOn
    const originalName = button.dataset.originalName
    const shopId = button.dataset.shopId
    const treatmentId = button.dataset.treatmentId

    const form = this.element.querySelector('form');
    let url = form.getAttribute('action');

    if (url.includes('MASTER_TREATMENT_ID')) {
        url = url.replace('MASTER_TREATMENT_ID', masterTreatmentId);
        url = url.replace('SHOP_ID', shopId);
        url = url.replace('TREATMENT_ID', treatmentId);
        form.setAttribute('action', url);
    }
    
    if (this.hasModalTitleTarget) {
      this.modalTitleTarget.textContent = `${originalName} - ${this.modalTitleTarget.dataset.baseTitle}`;
    }

    this.originalDateTarget.textContent = originalExpiresOn;
    this.errorMessagesTarget.textContent = '';
    this.expiresOnInputTarget.value = ''; // 日付フィールドを空に
    
    // 💡 モーダルを開くたびに無期限チェックをリセット
    if (this.hasNoExpirationCheckTarget) {
      this.noExpirationCheckTarget.checked = false;
      this.expiresOnInputTarget.disabled = false;
    }
  }

  // 💡 追加: チェックボックスと日付フィールドの連動
  toggleNoExpiration() {
    const isChecked = this.noExpirationCheckTarget.checked;
    
    // チェックが入っていたら日付フィールドを無効化し、値をクリア
    this.expiresOnInputTarget.disabled = isChecked;
    if (isChecked) {
      this.expiresOnInputTarget.value = '';
    }
  }

  // ----------------------------------------------------
  // 2. フォーム送信処理 (Fetch API を使用し、クライアント側で完全に制御)
  // ----------------------------------------------------
  async submitForm(event) {
    event.preventDefault(); 

    this.errorMessagesTarget.textContent = '';
    this.submitButtonTarget.disabled = true;

    const form = this.element.querySelector('form');
    const url = form.getAttribute('action');
    
    // 💡 修正: let を使用
    let newExpiresOn;

    if (this.hasNoExpirationCheckTarget && this.noExpirationCheckTarget.checked) {
      // 💡 無期限がチェックされている場合: null を送信
      newExpiresOn = null;
    } else {
      // 💡 チェックされていない場合: 日付フィールドの値を取得
      newExpiresOn = this.expiresOnInputTarget.value;
      
      // 日付が空で無期限チェックもされていない場合は、エラーを出す
      if (!newExpiresOn) {
        this.errorMessagesTarget.textContent = "新しい有効期限を選択するか、「無期限にする」にチェックを入れてください。";
        this.submitButtonTarget.disabled = false;
        return;
      }
    }
    
    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content,
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          master_treatment: {
            expires_on: newExpiresOn
          }
        })
      });

      this.submitButtonTarget.disabled = false;
      
      if (response.ok || response.status === 200) {
        
        const modal = bootstrap.Modal.getInstance(this.element);
        if (modal) {
          modal.hide();
        }

        console.log("更新成功。モーダルを閉じ、ページをリロードします。");
        const destination = hasWalletTabContext() ? walletTabReturnUrl() : window.location.href;
        Turbo.visit(destination); 

      } else {
        const errorData = await response.json();
        const errorMessage = errorData.errors ? errorData.errors.join('<br>') : "有効期限の更新に失敗しました。";
        
        this.errorMessagesTarget.innerHTML = `エラーが発生しました:<br>${errorMessage}`;
        console.error("更新失敗:", errorData);
      }
      
    } catch (error) {
      this.submitButtonTarget.disabled = false;
      this.errorMessagesTarget.textContent = `通信エラー: ${error.message}`;
      console.error("Fetchエラー:", error);
    }
  }
}